import { render, staticRenderFns } from "./DictAdd.vue?vue&type=template&id=4a810bfc&scoped=true&"
import script from "./DictAdd.vue?vue&type=script&lang=js&"
export * from "./DictAdd.vue?vue&type=script&lang=js&"
import style0 from "./DictAdd.vue?vue&type=style&index=0&id=4a810bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a810bfc",
  null
  
)

export default component.exports